import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useToastError } from "@/components/ui/use-toast";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminUserDTO, AdminUserTeamDTO } from "@shaarp/common";
import { useEffect, useState } from "react";
import DataTableAdminUserTeams from "../data-table-users-team/data-table-admin-user-teams";

export function DialogAdminUserTeams({
  user,
  open,
  onClose,
}: {
  user: AdminUserDTO;
  open: boolean;
  onClose: () => void;
}) {
  const toastError = useToastError();
  const api = useApi();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teams, setTeams] = useState<AdminUserTeamDTO[]>([]);

  useEffect(() => {
    if (open && user.id) {
      fetchTeams();
    }
  }, [open, user.id]);

  const fetchTeams = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get<AdminUserTeamDTO[]>(
        `/admin/user/${user.id}/teams`
      );
      setTeams(data || []);
    } catch (e) {
      toastError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>
            {t("admin.dataTableAdminUsers.dialogs.teams.title", {
              userName: user.fullName || "Nom d'utilisateur indisponible",
            })}
          </DialogTitle>
          <DialogDescription>
            {t("admin.dataTableAdminUsers.dialogs.teams.description", {
              count: teams.length,
            })}
          </DialogDescription>
        </DialogHeader>
        <div className="py-3 space-y-5 border-t">
          <DataTableAdminUserTeams
            teams={teams}
            isLoading={isLoading}
            emptyText={t("admin.dataTableAdminUsers.dialogs.teams.empty")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
